import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSelectedValue]'
})
export class SelectedValueDirective implements OnInit {


  constructor(private el: ElementRef, private renderer: Renderer2) {

  }
  ngOnInit() {
  }
  @HostListener('change') change() {
    setTimeout(() => {
      const selectedValue = this.el.nativeElement.querySelectorAll('.ng-value');
      let container = this.el.nativeElement.querySelector('.ng-value-container');
      const node = document.createElement("span");
      const textnode = document.createTextNode( `+${selectedValue.length}`);
      node.classList.add("length");
      for (let i = 0; i <= selectedValue.length - 1; i++) {
        if( i >=3 ){
          selectedValue[i].classList.add('d-none');
        }else{
          selectedValue[i].classList.remove('d-none');

        }
      }
      if (selectedValue.length >= 4) {
       if(!document.getElementsByClassName("length").length){
        node.appendChild(textnode);
        this.renderer.appendChild(container, node);
       }else{
        document.getElementsByClassName("length")[0].innerHTML = `+${selectedValue.length}`
       } 
        
      }else{
        if(document.getElementsByClassName("length").length)
         document.getElementsByClassName("length")[0].remove()
      }
    }, 100);
  }
}
